module.exports = __webpack_public_path__ + "static/media/CoA.fa0b8d98.png";